module.exports = __webpack_public_path__ + "img/nexultra-L-30.c2c7ae1c.jpg";